/*
 * @Author: Arthur Chen achen@insight2soft.com
 * @Date: 2025-09-26 10:20:38
 * @LastEditors: Arthur Chen achen@insight2soft.com
 * @LastEditTime: 2025-12-24 21:32:07
 * @FilePath: \frontend\src\utils\api.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';
// export const baseURL = 'http://localhost:8000/';
// export const baseURL = 'http://192.168.2.2:8000/';
export const baseURL = 'https://cti-ai-report.i2lims.com/';
// export const wsURL = 'ws://localhost:8000/';
export const wsURL = 'wss://cti-ai-report.i2lims.com/';

/** 此封装只适用需要token的接口。Login不适用 */
const api = axios.create({
  baseURL,
  timeout: 100000,
});

const checkAndRefreshToken = async () => {
  const token = localStorage.getItem('token');
  if (!token) return;
  try {
    const payloadBase64 = token.split('.')[1];
    const payloadJson = atob(payloadBase64);
    const payload = JSON.parse(payloadJson);
    const exp = payload.exp; // JWT 过期时间（单位：秒）
    const now = Math.floor(Date.now() / 1000);
    const oneHourLater = now + 60 * 5;
    // 预设：距离过期时间≤1h时刷新token
    if (exp <= oneHourLater) {
      const response = await axios.post(`${baseURL}api/token/refresh/`, {refresh: localStorage.getItem('refresh') || ''});
      const newToken = response.data?.access;
      if (newToken) {
        localStorage.setItem('token', newToken);
      }
      if (response.data?.refresh) {
        localStorage.setItem('refresh', response.data.refresh);
      }
    }
  } catch (error) {
    console.error('校验或刷新 token 失败：', error);
  }
};

api.interceptors.request.use(
  (config) => {
    checkAndRefreshToken();
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  // (error) => {
  //   if (error.response && error.response.status === 403) {
  //     localStorage.removeItem('token');
  //     window.location.href = '/login';
  //   }
  //   return Promise.reject(error);
  // }
);

export default api;